import { t } from "i18next";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

const InviteModal = ({ show, setShow, inviteLink }) => {
  const handleClose = () => setShow(false);

  // Funzione di condivisione con fallback
  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Unisciti a Volunteer",
          text: "Unisciti a Volunteer per restare sempre in contatto con la tua associazione e vivere nel modo più semplice la tua esperienza come socio e volontario! \n\nVolunteer, la tua associazione a portata di app!",
          url: inviteLink,
        })
        .then(() => {
          console.log("Condiviso con successo");
          setShow(false);
        })
        .catch((error) => {
          console.log("Errore nella condivisione", error);
        });
    } else {
      alert(
        "Condivisione nativa non supportata. Usa i pulsanti per condividere manualmente."
      );
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("dashboard.invite_volunteer_modal_title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t("dashboard.invite_volunteer_modal_subtitle")}</p>
        <input
          type="text"
          className="form-control mb-3"
          value={inviteLink}
          readOnly
          onClick={(e) => e.target.select()}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleClose}>
          {t("common.close")}
        </Button>
        <Button variant="success" onClick={handleShare}>
          {t("common.share")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InviteModal;
